import React from 'react';
import {Flex} from "@chakra-ui/layout";
import {NavLink} from "react-router-dom";
import {Image, Link, Text} from "@chakra-ui/react";
import Profile from "../../images/header/profile.svg";
import Logo from "../utilities/Logo";
import {StateType} from "../../store/store";
import {useSelector} from "react-redux";

export type NavProps = {
  role: string
}

function NavBar({role}: NavProps) {

  return (
    <nav>
      <Flex flexDirection={"row"} justifyContent={"space-between"} px={5} py={4} bgColor={"brand.white"}
            boxShadow={"2xl"}>
        <Logo _fontSize={"2xl"} _mt={0} />
        <Flex flexDirection={"row"}>
          <Image
            boxSize="30px"
            objectFit="cover"
            mr={"12px"}
            src={Profile}
            alt="profile icon"
            alignSelf={"center"}
          />
          <Link as={NavLink} to={`/${role}`} textTransform={"capitalize"} alignSelf={"center"}>
            {role}
          </Link>
        </Flex>
      </Flex>
    </nav>
  );
}

export default NavBar;